import {createContext} from 'react';
import FullCalendar from '@fullcalendar/react';

const CalendarRefContext = createContext<React.RefObject<FullCalendar>>({
  current: null,
});

export default CalendarRefContext;
